export const FETCH_WEB_MINIWIDGET_REQUEST = "FETCH_WEB_MINIWIDGET_REQUEST";
export const FETCH_WEB_MINIWIDGET_SUCCESS = "FETCH_WEB_MINIWIDGET_SUCCESS";
export const FETCH_WEB_MINIWIDGET_FAILURE = "FETCH_WEB_MINIWIDGET_FAILURE";

export const FETCH_WEB_VISITORS_REQUEST = "FETCH_WEB_VISITORS_REQUEST";
export const FETCH_WEB_VISITORS_SUCCESS = "FETCH_WEB_VISITORS_SUCCESS";
export const FETCH_WEB_VISITORS_FAILURE = "FETCH_WEB_VISITORS_FAILURE";

export const FETCH_BETA_SALES_REQUEST = "FETCH_BETA_SALES_REQUEST";
export const FETCH_BETA_SALES_SUCCESS = "FETCH_BETA_SALES_SUCCESS";
export const FETCH_BETA_SALES_FAILURE = "FETCH_BETA_SALES_FAILURE";

export const APPLICTION_INSTALATION_REQUEST = "APPLICTION_INSTALATION_REQUEST";
export const APPLICTION_INSTALATION_SUCCESS = "APPLICTION_INSTALATION_SUCCESS";
export const APPLICTION_INSTALATION_FAILURE = "APPLICTION_INSTALATION_FAILURE";

export const WEB_WEEKLY_INSIGHT_REQUEST = "WEB_WEEKLY_INSIGHT_REQUEST";
export const WEB_WEEKLY_INSIGHT_SUCCESS = "WEB_WEEKLY_INSIGHT_SUCCESS";
export const WEB_WEEKLY_INSIGHT_FAILURE = "WEB_WEEKLY_INSIGHT_FAILURE";

export const ANDROID_USER_ANALYTICS_REQUEST = "ANDROID_USER_ANALYTICS_REQUEST";
export const ANDROID_USER_ANALYTICS_SUCCESS = "ANDROID_USER_ANALYTICS_SUCCESS";
export const ANDROID_USER_ANALYTICS_FAILURE = "ANDROID_USER_ANALYTICS_FAILURE";

export const ANDROID_RECENT_ACTIVE_REQUEST = "ANDROID_RECENT_ACTIVE_REQUEST";
export const ANDROID_RECENT_ACTIVE_SUCCESS = "ANDROID_RECENT_ACTIVE_SUCCESS";
export const ANDROID_RECENT_ACTIVE_FAILURE = "ANDROID_RECENT_ACTIVE_FAILURE";

export const NEW_BETA_JOINER_REQUEST = "NEW_BETA_JOINER_REQUEST";
export const NEW_BETA_JOINER_SUCCESS = "NEW_BETA_JOINER_SUCCESS";
export const NEW_BETA_JOINER_FAILURE = "NEW_BETA_JOINER_FAILURE";

export const fetchMiniWidgetDataRequest = () => ({
    type: FETCH_WEB_MINIWIDGET_REQUEST,
});

export const fetchMiniWidgetDataSuccess = (data) => ({
    type: FETCH_WEB_MINIWIDGET_SUCCESS,
    payload: data,
});

export const fetchMiniWidgetDataFailure = (error) => ({
    type: FETCH_WEB_MINIWIDGET_FAILURE,
    payload: error,
});

export const fetchWebVisitorsRequest = (days) => ({
    type: FETCH_WEB_VISITORS_REQUEST,
    payload: { days },
});

export const fetchWebVisitorsSuccess = (data) => ({
    type: FETCH_WEB_VISITORS_SUCCESS,
    payload: data,
});

export const fetchWebVisitorsFailure = (error) => ({
    type: FETCH_WEB_VISITORS_FAILURE,
    payload: error,
});

export const fetchBetaSalesRequest = (days) => ({
    type: FETCH_BETA_SALES_REQUEST,
    payload: { days },
});

export const fetchBetaSalesSuccess = (data) => ({
    type: FETCH_BETA_SALES_SUCCESS,
    payload: data,
});

export const fetchBetaSalesFailure = (error) => ({
    type: FETCH_BETA_SALES_FAILURE,
    payload: error,
});

export const fetchApplicationInstalationRequest = (days) => ({
    type: APPLICTION_INSTALATION_REQUEST,
    payload: { days },
});

export const fetchApplicationInstalationSuccess = (data) => ({
    type: APPLICTION_INSTALATION_SUCCESS,
    payload: data,
});

export const fetchApplicationInstalationFailure = (error) => ({
    type: APPLICTION_INSTALATION_FAILURE,
    payload: error,
});

export const fetchWebWeeklyInsightRequest = () => ({
    type: WEB_WEEKLY_INSIGHT_REQUEST,
});

export const fetchWebWeeklyInsightSuccess = (data) => ({
    type: WEB_WEEKLY_INSIGHT_SUCCESS,
    payload: data,
});

export const fetchWebWeeklyInsightFailure = (error) => ({
    type: WEB_WEEKLY_INSIGHT_FAILURE,
    payload: error,
});

export const fetchAndroidAnalyticsRequest = () => ({
    type: ANDROID_USER_ANALYTICS_REQUEST,
});

export const fetchAndroidAnalyticsSuccess = (data) => ({
    type: ANDROID_USER_ANALYTICS_SUCCESS,
    payload: data,
});

export const fetchAndroidAnalyticsFailure = (error) => ({
    type: ANDROID_USER_ANALYTICS_FAILURE,
    payload: error,
});

export const fetchRecentActiveRequest = (days) => ({
    type: ANDROID_RECENT_ACTIVE_REQUEST,
    payload: { days },
});

export const fetchRecentActiveSuccess = (data) => ({
    type: ANDROID_RECENT_ACTIVE_SUCCESS,
    payload: data,
});

export const fetchRecentActiveFailure = (error) => ({
    type: ANDROID_RECENT_ACTIVE_FAILURE,
    payload: error,
});

export const fetchNewBetaJoinerRequest = (days) => ({
    type: NEW_BETA_JOINER_REQUEST,
    payload: { days },
});

export const fetchNewBetaJoinerSuccess = (data) => ({
    type: NEW_BETA_JOINER_SUCCESS,
    payload: data,
});

export const fetchNewBetaJoinerFailure = (error) => ({
    type: NEW_BETA_JOINER_FAILURE,
    payload: error,
});